// tipAtP1ArrowTools.js — Dedicated sequential collectors for DrawRules whose library JSDoc
// puts the arrowhead tip at P1 and whose natural gesture is tip-last (tickets 03/04).
//
// LINE29 (Ambush): P1=tip; P2 & P3 = ends of curved back.
// LINE30 (Exploit dashed arrow): P1=tip; P2=spine end; P3=tail-length control.
//
// Point-role JSDoc differs — do NOT collapse these into one DrawRule abstraction beyond the
// shared createSequentialCollector primitive (ticket 01). Both happen to use the same
// tip-to-front reorder because both collect tip last.

import { DrawRules } from '@armyc2.c5isr.renderer/mil-sym-ts-web';
import Feature from 'ol/Feature';
import { LineString } from 'ol/geom';
import { registerDrawInteraction } from '../customDrawInteractions';
import { createSequentialCollector, tipToFront } from './sequentialCollector';
import { PREVIEW_LINE_BLUE } from './drawPreviewStyles';

function roleForIndex(i) {
    // Click order: early points = rear/back geometry (anchor); last aimed click = tip (direction)
    return i === 0 ? 'anchor' : 'direction';
}

function makeTipAtP1ThreePointCollector(map, opts) {
    return createSequentialCollector(map, {
        minCount: 3,
        maxCount: 3,
        onFinish: opts.onFinish,
        reorderOnFinish: tipToFront,
        sidc: opts.sidc || null,
        previewMinPoints: 2,
        cursorFirst: true,
        applyReorderToPreview: false,
        roleForIndex,
        styleResolver: () => PREVIEW_LINE_BLUE,
        onSketchUpdate: ({ previewSource, collected3857, cursorCoord3857 }) => {
            const pts = cursorCoord3857 ? [...collected3857, cursorCoord3857] : collected3857;
            if (pts.length >= 2) previewSource.addFeature(new Feature(new LineString(pts)));
        },
    });
}

registerDrawInteraction(DrawRules.LINE29, (map, opts) => makeTipAtP1ThreePointCollector(map, opts));
registerDrawInteraction(DrawRules.LINE30, (map, opts) => makeTipAtP1ThreePointCollector(map, opts));
